import { COM_CONTRIBUTOR_STATUS_COLORS_THEME } from 'config/constants';

// eslint-disable-next-line import/prefer-default-export
export const getStatusColor = (theme, value = 'NO-STATUS') => {
  if (value === 'NO-STATUS') {
    return theme.palette[COM_CONTRIBUTOR_STATUS_COLORS_THEME[value]][400];
  }
  return theme.palette[COM_CONTRIBUTOR_STATUS_COLORS_THEME[value]]?.main;
};
